import { API_URL, getCachedSessionId } from 'src/services/common';

import { FetchContentReviewsResponseData } from './interfaces/fetchContentReviewsResponseData.interface';
import { api } from '../../../../util/axios-instance';

export const fetchContentReviews = async (params: {
  orderBy: string;
  orderDirection: string;
  page: string;
  pageSize: string;
  projectId: string;
}): Promise<FetchContentReviewsResponseData | undefined> => {
  const { projectId, page, pageSize, orderBy, orderDirection } = params;
  const response = await api.get<FetchContentReviewsResponseData>(
    `${API_URL}/v1/project/${projectId}/contentReview/?page=${page}&limit=${pageSize}&orderBy=${orderBy}&orderDirection=${orderDirection}`,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );

  return response.data;
};
